import { Controller } from "@hotwired/stimulus"
import '@simonwep/pickr/dist/themes/nano.min.css';
import Pickr from '@simonwep/pickr'

// Connects to data-controller="pickr"
export default class extends Controller {
  static targets = [
    "backgroundColorPicker",
    "backgroundColorInput",
    "formBackground"
  ]

  static values = {
    swatches: Array,
  }

  connect() {
    // No-op when there's no color-picker target on the page (e.g. the slide
    // edit form lists this controller alongside others in data-controller, but
    // the styling panel that hosts the picker isn't always rendered).
    if (!this.hasBackgroundColorPickerTarget || !this.hasBackgroundColorInputTarget) return

    const pickr = Pickr.create({
        el: this.backgroundColorPickerTarget,
        theme: 'nano', // or 'classic',, 'monolith' or 'nano'

        swatches: this.swatchesValue,
        default: this.backgroundColorInputTarget.value || "#ffffff",

        components: {

            // Main components
            // preview: true,
            opacity: true,
            hue: true,

            // Input / output Options
            interaction: {
                hex: true,
                rgba: true,
                hsla: true,
                hsva: true,
                cmyk: true,
                input: true,
                clear: true,
                save: true
            }
        }
    });

    pickr.on('init', instance => {
      // If no initial value, show cleared/empty state
      if (!this.backgroundColorInputTarget.value) {
        instance.setColor(null)
      }
    })

    pickr.on('save', (color, instance) => {
      if (!color) {
        this.backgroundColorInputTarget.value = ""
        if (this.hasFormBackgroundTarget) {
          this.formBackgroundTarget.style.backgroundColor = ""
        }
      }
      pickr.hide()
    })

    pickr.on('clear', (color, instance) => {
      if (this.hasFormBackgroundTarget) {
        this.formBackgroundTarget.style.backgroundColor = ""
      }
      this.backgroundColorInputTarget.value = ""
    })

    pickr.on('change', (color, source, instance) => {
      let hexColor = `#${color.toHEXA().join("")}`
      if (this.hasFormBackgroundTarget) {
        this.formBackgroundTarget.style.backgroundColor = hexColor
      }
      this.backgroundColorInputTarget.value = hexColor
    })
  }
}
